<footer class="bg-gray-200 py-4 mt-auto">
    <div class="container mx-auto text-center">
        <p>&copy; 2024 Document Finder. All rights reserved.</p>
    </div>
</footer>